/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonISO3166CountryCodeFromJSON, CommonISO3166CountryCodeToJSON, } from './CommonISO3166CountryCode';
/**
 * Check if a given object implements the InternalCommonLocation interface.
 */
export function instanceOfInternalCommonLocation(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('country' in value) || value['country'] === undefined)
        return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined)
        return false;
    if (!('latitude' in value) || value['latitude'] === undefined)
        return false;
    if (!('longitude' in value) || value['longitude'] === undefined)
        return false;
    return true;
}
export function InternalCommonLocationFromJSON(json) {
    return InternalCommonLocationFromJSONTyped(json, false);
}
export function InternalCommonLocationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'address': json['address'],
        'city': json['city'],
        'state': json['state'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'country': json['country'],
        'countryCode': CommonISO3166CountryCodeFromJSON(json['country_code']),
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}
export function InternalCommonLocationToJSON(json) {
    return InternalCommonLocationToJSONTyped(json, false);
}
export function InternalCommonLocationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'address': value['address'],
        'city': value['city'],
        'state': value['state'],
        'postal_code': value['postalCode'],
        'country': value['country'],
        'country_code': CommonISO3166CountryCodeToJSON(value['countryCode']),
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'timezone': value['timezone'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}
